var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7018 17.7018L20.7018 7.70175C20.8947 7.52632 21 7.2807 21 7C21 6.45614 20.5439 6 20 6C19.7193 6 19.4737 6.10526 19.2982 6.29825L9.29825 16.2982C9.10526 16.4737 9 16.7193 9 17C9 17.5439 9.45614 18 10 18C10.2807 18 10.5263 17.8947 10.7018 17.7018ZM3.29825 11.7018L9.29825 17.7018C9.47369 17.8947 9.7193 18 10 18C10.5439 18 11 17.5439 11 17C11 16.7193 10.8947 16.4737 10.7018 16.2982L4.70175 10.2982C4.52632 10.1053 4.2807 10 4 10C3.45614 10 3 10.4561 3 11C3 11.2807 3.10526 11.5263 3.29825 11.7018Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutlined);
export default __webpack_public_path__ + "static/media/check_outlined.9dba2dbf.svg";
export { ForwardRef as ReactComponent };